import type { IApiClientConfig } from "../types/api-client-config.interface";

export interface IApiEndpointsConfig {
  main: {
    v1: IApiClientConfig;
    v2: IApiClientConfig;
    v3: IApiClientConfig;
  };
  auth: {
    v1: IApiClientConfig;
    v2: IApiClientConfig;
  };
  cms: IApiClientConfig;
  meilisearch: IApiClientConfig;
}

export function getApiEndpointsConfig(): IApiEndpointsConfig {
  const baseUrl = process.env.REACT_APP_MAIN_URL || "";
  const authUrl = process.env.REACT_APP_AUTH_URL || baseUrl;
  const cmsUrl = process.env.REACT_APP_CMS_URL || "";
  const cmsToken = process.env.REACT_APP_BONUSX_CMS_TOKEN || "";
  const meilisearchUrl = process.env.REACT_APP_MEILISEARCH_HOST || "";
  const meilisearchKey = process.env.REACT_APP_MEILISEARCH_KEY || "";

  return {
    main: {
      v1: {
        baseURL: `${baseUrl}/sapi/api/v1`,
        withCredentials: true,
      },
      v2: {
        baseURL: `${baseUrl}/sapi/api/v2`,
        withCredentials: true,
      },
      v3: {
        baseURL: `${baseUrl}/sapi/api/v3`,
        withCredentials: true,
      },
    },
    auth: {
      v1: {
        baseURL: `${authUrl}/auth/api/v1`,
        withCredentials: true,
      },
      v2: {
        baseURL: `${authUrl}/auth/api/v2`,
        withCredentials: true,
      },
    },
    cms: {
      baseURL: cmsUrl,
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${cmsToken}`,
      },
    },
    meilisearch: {
      baseURL: meilisearchUrl,
      withCredentials: false,
      headers: {
        Authorization: `Bearer ${meilisearchKey}`,
      },
    },
  };
}
